import * as moment from 'moment'

import { ReduxAction } from './ReduxUtils'
import { getStore } from './Store'

export interface ClockState {
    time: string;
    showAtTables: boolean;
}
const TICK = 'TICK'
const SHOW_CLOCK = 'SHOW_CLOCK'

const initialState = {
	time: moment().format('LT'),
	showAtTables: false,
}

setInterval(() => {
	tick()
}, 5000)

const tick = () => getStore().dispatch(_tick() as any)
export const showClock = () => getStore().dispatch({ type: SHOW_CLOCK, payload: {} } as any)
function _tick() {
	return {
		type: TICK,
		payload: moment().format('LT'),
		createdTime: Date.now(),
	}
}

export function clockReducer(state: ClockState = initialState, action: ReduxAction<string>): ClockState {
	switch (action.type) {
	case SHOW_CLOCK:
		return {...state,  showAtTables: true}
	case TICK:
		return {...state,  time: action.payload as string}
	default:
		return state
	}
}
